import { Switch } from '@spotted-zebra-uk/ui-components';
import styles from './IntegrationsTab.module.scss';

/** Switch with its label and an always-visible description underneath. */
export function SwitchRow({
  id,
  label,
  caption,
  value,
  switchTestId,
  onToggle,
}: {
  id: string;
  label: string;
  caption: string;
  value: boolean;
  switchTestId: string;
  onToggle: (toggled: boolean) => void;
}) {
  return (
    <div className={styles.switchRow}>
      <div className={styles.switchText}>
        <span className={styles.switchLabel}>{label}</span>
        <span className={styles.switchCaption}>{caption}</span>
      </div>
      <Switch
        id={id}
        value={value}
        dataTestId={switchTestId}
        onToggle={onToggle}
      />
    </div>
  );
}
